module.exports = __webpack_public_path__ + "fonts/BEER.778e09e5.ttf";